const commonHelpers = require('../helpers/commonHelpers');
const repeatOrder = require('./repeatOrder');
const device = window.matchMedia('(max-device-width: 991px)').matches;
const whitePackSKU = $('.pack-grid [data-pack-name="blanco"]').parent().data('glass-id');
const btnGoBackModalHTMLContent = $('.receta.regresar span').html();
const ENTER = 'Enter';

var recetaHelpers = require("./recetaHelpers");
var pdpCoutas = parseInt($("[data-pdpcuotas]").text()).toFixed(0);
var cuotasDisponiblesContainer = document.querySelector('.pdp__texto-cuotas-disponibles');
var pdpPrices = document.getElementById('pdpPrices');
var allPrices = pdpPrices.querySelectorAll('.value');
var finalPriceQuantity = 0;
let blueFilter = $(".filtro-azul-option-cristales").prop('checked');
let isBlueFilterActive = $('.step-filtro-luz-azul-wrapper').css('display') == 'block' ? true:false;
let screen = window.matchMedia('(max-width: 991px)');
let isMobile;
let mobilModalRemoveCommaChanged = true;
let mouseIsInside = false;

function toggleVisibility(selector, shouldShow) {
  const $element = $(selector);
  if (!$element.length) return; // Evita errores si el selector no existe

  $element.toggleClass('d-none', !shouldShow);
}

function getCurrentStep(){
  let $element = $('.tratamientos.continuar');
  const currentStep = $element.attr('sol-step');

  return parseInt(currentStep, 10) || 1
}

// Handle step change on btn continuar sol optics
function handleStepChangeBtn(value) {
  let $elemento = $('.tratamientos.continuar');
  if (!$elemento.attr('sol-step')) {
    $elemento.attr('sol-step', 1);
  }
  let pasoActual = parseInt($elemento.attr('sol-step')) || 1;
  let nuevoPaso = Math.max(1, pasoActual + value);
  $elemento.attr('sol-step', nuevoPaso);
}

allPrices.forEach((el) => {
  if (el.className == 'value') {
    finalPriceQuantity++;
  };
});

if (cuotasDisponiblesContainer && cuotasDisponiblesContainer.length > 0) {
  if (finalPriceQuantity == 1) {
    cuotasDisponiblesContainer.style.display = 'block';
  } else {
    if (finalPriceQuantity.length == 1) {
      cuotasDisponiblesContainer.style.display = 'block';
    };
    cuotasDisponiblesContainer.style.display = 'none';
  }
}

// Remove styles to
$('#receta-file-name').removeClass('load');
$('.carga-distancia-pupilar').removeClass('load');

function clearCristalesDesciption(element) {
  let description = element.text().trim().slice(0,-1);
  element.text(description);
}

function disabledBtnRegresarModal() {
  let btnGoBackModal = $('.receta.regresar').is('[disabled]');
  if (btnGoBackModal) {
    $('.receta.regresar span').html('');
  }
}

function init() {
  // Load wishlist product data
  // Restaurar el estado de los productos en la wishlist
  const wishlitHelper = require('../product/wishlistHeart');
  wishlitHelper.updateHeartButtons(true);
  $('[data-flow-store-subscription]').data('flow-store-subscription') ? $('.tab-subscription-pdp').trigger('click') : null;  
  disabledBtnRegresarModal();
  if(device){
    isMobile = true;
    $(".step-filtro-luz-azul-wrapper").addClass("d-none");
    // Delete ',' on cristal description
    const element = $('.carga-distancia-pupilar');
    const placeHolder = device ? 'placeholder-phone' : 'placeholder';
    changePlaceHolder(element.attr(placeHolder));
    mobilModalRemoveCommas();

    // Validate if the blue filter switch is checked on mobile modal optics
    if (blueFilter) {
      $('#filtro-azul-option-cristalesMobile').trigger('click');
      $('#btnContinuarMobile').prop('disabled', false);
    }
  }

  $('.vision-type-option').removeClass('selected');
  $('.vision-type-option input:checked').prop('checked', false);
  
  // Initialize package selection handlers
  bttnSelectecGlass();
  
  // Initialize type toggle handlers
  initTypeToggleHandlers();
}

/**
 * Initialize type toggle handlers for Sólido/Degradé
 */
function initTypeToggleHandlers() {
  $(document).on('change', '.color-type-toggle', function() {
    var $this = $(this);
    var typeId = $this.data('type-id');
    var isChecked = $this.prop('checked');
    
    console.log('Type toggle changed:', typeId, isChecked);
    
    // Find the treatment container and color section
    var treatmentContainer = $this.closest('.adds-color-options');
    var colorSection = treatmentContainer.find('.color-section');
    
    // Uncheck other type toggles (only one can be selected)
    $('.color-type-toggle').not(this).prop('checked', false);
    
    if (isChecked) {
      console.log('Showing colors for type:', typeId);
      
      // Get treatment config from the selected treatment
      var selectedTreatment = $('.adds-extra-switchs:checked');
      var treatmentConfig = selectedTreatment.data('treatment-config');
      
      console.log('Selected treatment:', selectedTreatment);
      console.log('Treatment config:', treatmentConfig);
      
      if (treatmentConfig && treatmentConfig.types) {
        fillTreatmentSubColors(treatmentContainer, treatmentConfig, $this);
      } else {
        console.log('Treatment config or types not found');
      }
    } else {
      console.log('Hiding colors for type:', typeId);
      colorSection.empty();
    }
  });
}

function mobilModalRemoveCommas() {
  if (!mobilModalRemoveCommaChanged) {
    return;
  }

  mobilModalRemoveCommaChanged = false;

  const cristalesDescription = $('.cristalesDescription');
  if(cristalesDescription.length > 0) {
    cristalesDescription.map((cristalDescription)=>{
      clearCristalesDesciption(cristalesDescription.eq(cristalDescription))
    });
  }
}

screen.addEventListener('change', function(screen){
   if (screen.matches) {
      isMobile = true;
      $(".step-filtro-luz-azul-wrapper").addClass("d-none");
      init();
    } else {
      isMobile = false;
      $(".step-filtro-luz-azul-wrapper").removeClass("d-none");
    }
})

/**
 * @description - identifies the current progress breadcrumb active step
 * @returns {number} - the active step number
 */
function identifyCurrentPos() {
  let currentPos = $('.cristales__step-circles-wrapper').data('current-pos');

  if(currentPos) {
    return currentPos;
  }

  $('.cristales__step-circles-wrapper').find('.circle-text').each(function(i, el) {
    if($(el).find('.step-circle.done-step-circle.done-icon').length > 0) {
      currentPos = i + 1;
    }
  });

  $('.cristales__step-circles-wrapper').data('current-pos', currentPos);

  return currentPos;
}

/**
 * @description - Method that changes the progress breadcrumb status based on the direction progress
 * and the current step
 * @param {string} direction - 'next' or 'prev' values
 */
function handleStepChange(direction) {
    let pos = identifyCurrentPos();

    if(direction === 'next') {
        const currentStepCircle = $('.cristales__step-circles-wrapper').find('.circle-text')[pos];
        $(currentStepCircle).find('.step-circle span').hide();
        $(currentStepCircle).find('.step-circle').addClass('done-step-circle').addClass('done-icon');
        $(currentStepCircle).next('.step-line').removeClass('inactive-line');
        $(currentStepCircle).find('.circle-bottom-text').removeClass('active-step');
        pos++;
        const activeStepCircle = $('.cristales__step-circles-wrapper').find('.circle-text')[pos];
        $(activeStepCircle).find('.step-circle').removeClass('inactive-circle');
        $(activeStepCircle).find('.step-circle span').css('color', '#0857c3').show();
        $(activeStepCircle).find('.circle-bottom-text').css('color', '#0857c3').addClass('active-step');
    } else if(direction === 'prev') {
        const currentStepCircle = $('.cristales__step-circles-wrapper').find('.circle-text')[pos];
        $(currentStepCircle).find('.step-circle').addClass('inactive-circle');
        $(currentStepCircle).find('.step-circle span').css('color', 'gray').show();
        $(currentStepCircle).prev('.step-line').addClass('inactive-line');
        $(currentStepCircle).find('.circle-bottom-text').css('color', 'gray').removeClass('active-step');
        pos--;
        const targetStepCircle = $('.cristales__step-circles-wrapper').find('.circle-text')[pos];
        $(targetStepCircle).find('.step-circle').removeClass('done-step-circle').removeClass('done-icon');
        $(targetStepCircle).find('.step-circle span').css('color', '#0857c3').show();
        $(targetStepCircle).find('.circle-bottom-text').css('color', '#0857c3').addClass('active-step');
    }

    $('.cristales__step-circles-wrapper').data('current-pos', pos);
}

$('.carga-distancia-pupilar').on('focusout', function () {
  const recipeUrlSelector = $('.tab-subscription-pdp.active').length > 0 ? '#subscriptionRecipeUrl' : '#recipeUrl';

  let distanceIsValid = !$('.carga-distancia-pupilar + .invalid-feedback').is(':visible');
  let recipeUrlIsValid = ($(recipeUrlSelector).val()).length > 0;

  if (distanceIsValid && recipeUrlIsValid) {
    $('.footer-buttons__continuar.addToCart').removeClass('d-none');
  }
})

$('.carga-distancia-pupilar').on('keydown', function (event) {
    if ((event.key === ENTER) && $(this).val()) {
        $(this).trigger('change');
    }
})

function changePlaceHolder(placeholder){
    $('.carga-distancia-pupilar').attr('placeholder', placeholder);
}

$(document).on('click', '.pdp__attributes-section', function(e) {
  setTimeout(() => {
    if ($(this).find('.tab-subscription-pdp').hasClass('active')) {
      return;
    }
    const price = $('.pdp__prices').find('.sales > .value');
    const cuotas = $('.pdp_span-cuotas').attr('data-cuotasquantity');
    if (price && price.length === 1) {
      const finalPrice = price.attr('content');
      const divisionEnCuotas = (finalPrice / cuotas).toFixed(0);
      $('.pdp_span-cuotas').text(commonHelpers.formatMoneyToClp(divisionEnCuotas));
      if(cuotasDisponiblesContainer && cuotasDisponiblesContainer.length > 0) {
        cuotasDisponiblesContainer.style.display = 'block';
      }
    } else {
      if (cuotasDisponiblesContainer && cuotasDisponiblesContainer.length > 0) {
        cuotasDisponiblesContainer.style.display = 'none';
      }
    }
  }, 300);
});

/**
 * @description - valid all switchs colors of the main product, if the product is optic type
 * in the fotocromatic function
 * @param {string} items - switchs colors
 */
function validSwitchs(items) {
  let switchSelected = Array.from(items).find((item) => {
      return item.checked === true
  });
  return switchSelected && switchSelected.checked ? false : true;
}

/**
 * @description - show or hide the error messages in fotocromatic function
 * @param {string} fotocromatic function
 */
function showOrHideErrorFotocromatic(shouldShowError) {
    const sliderFotocromatic = $('.slider-fotocromatic');
    const filterColorname = $('.filter-color-name');
    const classErrorSwitch = 'switch-fotocromatic-error';
    const classErrorTxt = 'color-text-error-fotocromatic';
    const msjError = $('.container-msj-error-fotocromatic');
  if (shouldShowError) {
      sliderFotocromatic.addClass(classErrorSwitch);
      filterColorname.addClass(classErrorTxt);
      msjError.removeClass('d-none');
  } else {
      sliderFotocromatic.removeClass(classErrorSwitch);
      filterColorname.removeClass(classErrorTxt);
      msjError.addClass('d-none');
  }
}

/**
 * @description - validations to enable/disabled button pack continue
 * @param {string} btn - button pack continue
 */
function enableDisableBtn() {
    let shouldDisabledBtn = false;
    const btnContinue= $('button.pack.continuar');

    const classDisabledCustom = 'disabled-custom-fotocromatic';
    let switchsExtraColors = document.querySelectorAll('.extra-filter-switchs-fotocromatic');
    if ($('.banner-title-fotocromatic-color').is(':visible')) {
        shouldDisabledBtn = validSwitchs(switchsExtraColors);
    }

    if (shouldDisabledBtn) {
        btnContinue.addClass(classDisabledCustom);
    } else {
        btnContinue.removeClass(classDisabledCustom);
        showOrHideErrorFotocromatic(false);
    }
}

/**
 * @description - fotocromatic function disabled switches checkbox
 * @param {string} switch - switch checkBox
 */
function cleanSwitchesFotocromatic($this) {
    if ($this.attr('id') === 'fotocromatico-option-cristales-mobile' || 
        $this.attr('id') === 'fotocromatico-option-cristales'){
        $('.extra-filter-switchs-fotocromatic').prop('checked', false);
    }
}

/**
 * @description - selectJustOneFilter function that validate that just be select one filter in fotocromatic function
 * @param {boolean} checkBox - switch checkBox
 */
function selectJustOneFilter($this) {
    const switchsFotocromatics = $('input.extra-filter-switchs-fotocromatic');
    const lengthSwitchs = $('.extra-filter-switchs-fotocromatic').length;
    if (lengthSwitchs > 1) {
        switchsFotocromatics.each(function(index, check ){
            if (check.getAttribute('value') !== $this.val()) {
                check.checked = false;
            }
        });
    }
}


/**
 * @description - fotocromatic function change the view when the user select fotocromatic option
 * @param {string} switch - switch checkBox
 */
function fotocromaticFeature() {
    let checkedOptionFotocromatic = $('#fotocromatico-option-cristales, #fotocromatico-option-cristales-mobile').is(":checked")
    let checkedOptionFilterblue = $('#filtro-azul-option-cristales, #filtro-azul-option-cristalesMobile').is(":checked")
    let containerDisabledClass = 'container-filter-blue-color-disabled';
    let containerFilterBlue = '.container-filter-blue';
    let containerFotocromatic = $('.fotocromatico-img');
    let srcImageFakeFotocromatic = containerFotocromatic.data('src-fake');
    let srcImageFakeFilterBlue = $(containerFilterBlue).data('image-fake');
    let srcImageOrigin =  $(containerFilterBlue).data('image-origin');
    let srcImageFotocromaticOriginal =  $(containerFotocromatic).data('src-original');
    let iconFotocromatic = $('.fotocromatico-icon-sign');
    let iconFotocromaticMobile = $('.top-tooltip');
    let containerFotocromaticColors = '.banner-title-fotocromatic-color';
    if (checkedOptionFotocromatic) {
        $('.filtro-azul-pc-img').attr('src',srcImageFakeFilterBlue);
        $(containerFilterBlue).addClass(containerDisabledClass);
        $(containerFotocromaticColors).removeClass('d-none');
        $('.luz-azul-pc-texto').addClass(containerDisabledClass);
        iconFotocromaticMobile.addClass('fotocromatico-icon-sign-disabled');
    } else {
        $('.filtro-azul-pc-img').attr('src',srcImageOrigin);
        $(containerFilterBlue).removeClass(containerDisabledClass);
        $(containerFotocromaticColors).addClass('d-none');
        $('.luz-azul-pc-texto').removeClass(containerDisabledClass);
        iconFotocromaticMobile.removeClass('fotocromatico-icon-sign-disabled');
    }

    if (checkedOptionFilterblue) {
      $('.fotocromatico-img').attr('src', srcImageFakeFotocromatic);
      $('.fotocromatico-texto').addClass(containerDisabledClass);
      iconFotocromatic.addClass('fotocromatico-icon-sign-disabled');
      
    } else {
      $('.fotocromatico-img').attr('src', srcImageFotocromaticOriginal);
      $('.fotocromatico-texto').removeClass(containerDisabledClass);
      iconFotocromatic.removeClass('fotocromatico-icon-sign-disabled');
    }
    
}

function verifyIfAddonIsUnique($this) {
    var args= {};
    var FilterId = null;
    if ($this.is("#filtro-azul-option-cristales:checked") || $this.is("#filtro-azul-option-cristalesMobile:checked")) {
        args = {
            dataPrice: 'data-blue-filter-price',
            dataName: 'data-blue-filter-name',
            priceInfo: 'blue-filter-price',
            listPriceInfo: 'blue-filter-list-price'
        }
    }
    else if($this.is("#fotocromatico-option-cristales:checked, #fotocromatico-option-cristales-mobile:checked")) {
        args = {
            dataPrice: 'data-fotocromatic-price',
            dataName: 'data-fotocromatic-name',
            priceInfo: 'fotocromatic-price',
            listPriceInfo: 'fotocromatic-list-price'
        }
        
        FilterId = $('.extra-filter-switchs-fotocromatic:checked') ? $('.extra-filter-switchs-fotocromatic:checked').data('sku') : null;
    }

    if (FilterId === null || FilterId === undefined) {
        FilterId = $this.filter(":checked").parent().closest('.modal-cristales-switch').data('filter-id');
    }
    
    var FilterPrice = $("["+args.dataPrice+"]").data(args.priceInfo);
    // args is {} when neither branch matched; .data(undefined) returns the whole data object.
    var FilterListPrice = args.listPriceInfo
        ? $("["+args.dataPrice+"]").data(args.listPriceInfo)
        : null;
    var FilterName = $("["+args.dataName+"]").text();
    if ($this.is("#filtro-azul-option-cristalesMobile:checked")) {
      FilterName = $this.attr(args.dataName+"-mobile");
    }
    if ($this.is("#fotocromatico-option-cristales-mobile:checked")) {
      FilterName = $("["+args.dataName+"]").text();
      let filterVal;
      $("input.extra-filter-switchs-fotocromatic:checked").each(function(index, check ){
        filterVal = check.value;
      });
      FilterName += filterVal ? ` - ${filterVal}` : '';
    }
    return [FilterPrice, FilterId, FilterName, FilterListPrice];
}

/**
 * Renders "<label> <sales price> <struck-through list price>" into a summary slot.
 *
 * Uses text nodes rather than an HTML string: the labels come from catalogue data
 * (product.name via data-full-name, BlueFilter.fullName via data-blue-filter-name), so a
 * name containing & or < would otherwise be parsed as markup and truncate the line.
 * The list price is skipped when missing, zero or equal to the sales price.
 *
 * @param {Object} $target - jQuery slot to render into
 * @param {string} label - line label already formatted for display
 * @param {number|string} salesValue - price actually charged
 * @param {number|string} listValue - price book price
 * @returns {void}
 */
function renderSummaryLine($target, label, salesValue, listValue) {
    var sales = parseInt(salesValue, 10);
    var list = parseInt(listValue, 10);

    $target.empty().append(
        $('<span>').text(label + ' ' + commonHelpers.formatMoneyToClp(sales))
    );

    if (!isNaN(list) && list > 0 && list !== sales) {
        $target.append(
            $('<span>').addClass('summary-list-price')
                .text(commonHelpers.formatMoneyToClp(list))
        );
    }
}

/**
 * Renders the three totals lines in the modal footer, in the same shape the cart uses:
 * a Sub total built from list prices, a negative Descuento, and the Total actually
 * charged. Every number takes part in the arithmetic — an informative savings line
 * placed between the items and the total reads as an operand and does not add up.
 *
 * Add-on prices are resolved with global selectors, not with .closest().find(): on
 * mobile the switch and the price live in different containers, and the fotocromatic
 * price attribute only exists in the desktop template. Both desktop and mobile markup
 * are always in the DOM and merely hidden by CSS, which is why verifyIfAddonIsUnique
 * resolves them globally too.
 *
 * @param {number} salesTotal - the total actually charged, already summed by the caller
 * @returns {void}
 */
function renderTotalsBlock(salesTotal) {
    var listTotal = 0;

    // Every item that contributes to salesTotal must contribute here too, or the
    // Descuento line stops reconciling Sub total with Total.
    function accumulate(salesValue, listValue) {
        var sales = parseInt(salesValue, 10);
        var list = parseInt(listValue, 10);
        if (isNaN(sales)) {
            return;
        }
        listTotal += (!isNaN(list) && list > sales) ? list : sales;
    }

    var $main = $('[data-main-product-price]');
    var mainSales = parseInt($main.data('main-product-price'), 10);
    var mainList = parseInt($main.data('main-product-base-price'), 10);
    accumulate(mainSales, mainList);

    // The frame line is server-rendered, so its struck price is filled in here to stay
    // in sync with the BLANCO rule, which swaps the frame back to its list price.
    var $mainList = $('[data-main-product-list]');
    if (!isNaN(mainSales) && !isNaN(mainList) && mainList > mainSales) {
        $mainList.text(commonHelpers.formatMoneyToClp(mainList));
    } else {
        $mainList.text('');
    }

    var $lens = $('[data-selected-lens]').find('[data-price-glass]').first();
    accumulate($lens.data('price-glass'), $lens.data('list-price-glass'));

    if ($('#filtro-azul-option-cristales, #filtro-azul-option-cristalesMobile').is(':checked')) {
        var $blue = $('[data-blue-filter-price]');
        accumulate($blue.data('blue-filter-price'), $blue.data('blue-filter-list-price'));
    }

    // The fotocromatic colour switches carry a different class than the main filter
    // switches; toggleChangePriceTableModal treats them as a separate trigger.
    if ($('#fotocromatico-option-cristales, #fotocromatico-option-cristales-mobile').is(':checked')
            || $('.extra-filter-switchs-fotocromatic').is(':checked')) {
        var $foto = $('[data-fotocromatic-price]');
        accumulate($foto.data('fotocromatic-price'), $foto.data('fotocromatic-list-price'));
    }

    $('.adds-extra-switchs:checked').each(function () {
        accumulate($(this).data('adds-price'), $(this).data('adds-list-price'));
    });

    var $curvo = $('#curvo-si-adds');
    if ($curvo.is(':checked')) {
        accumulate($curvo.data('adds-extra-curvo-price'), $curvo.data('adds-extra-curvo-list-price'));
    }

    var $subtotalList = $('[data-subtotal-list]');
    $subtotalList.text(commonHelpers.formatMoneyToClp(listTotal));
    // sptInsurance adds the insurance price to both totals after this runs; it needs
    // the running value to increment.
    $subtotalList.attr('data-list-total-value', listTotal);

    var discount = listTotal - salesTotal;
    var $discount = $('[data-discount]');

    if (discount > 0) {
        $discount.empty().append(
            $('<span>').text($discount.data('label') + ' -'
                + commonHelpers.formatMoneyToClp(discount))
        );
        $('.subtotal__sublist').show();
    } else {
        // Without a discount, Sub total and Total are the same number, so showing both
        // is noise. Collapse back to the single Total line.
        $discount.empty();
        $('.subtotal__sublist').hide();
    }
}

/**
 * Applies one complement's simulated prices to every place the modal shows them.
 *
 * @param {string} sku - complement SKU
 * @param {Object} entry - { sales, list, formattedSales, formattedList, promotion }
 * @returns {void}
 */
function applyComplementPrice(sku, entry) {
    // Lens packages: desktop grid cell, mobile card header, and the hidden markers the
    // footer reads. Every [data-price-glass] inside the column for this SKU.
    var $columns = $('[data-glass-id="' + sku + '"]');

    $columns.find('[data-price-glass]').each(function () {
        $(this)
            .attr('data-price-glass', entry.sales)
            .data('price-glass', entry.sales)
            .attr('data-list-price-glass', entry.list)
            .data('list-price-glass', entry.list)
            .text(entry.formattedSales);
    });

    $columns.find('.pack-list-price').text(entry.promotion ? entry.formattedList : '');
    $columns.find('.mobile-pack-price .pack-sales-price b').text(entry.formattedSales);

    // Add-ons: every visible price wrapper is tagged with its own SKU, so there is no
    // guessing from the DOM hierarchy. Desktop and mobile variants both carry the tag.
    $('.addon-price-pair[data-addon-sku="' + sku + '"]').each(function () {
        var $pair = $(this);
        var $sales = $pair.find('.addon-sales-price');

        if ($sales.length) {
            // Sol Rx and the mobile blue filter keep the amount in a dedicated span,
            // prefixed with "+" in the Sol Rx layout.
            $sales.each(function () {
                var prefixed = $(this).text().indexOf('+') === 0;
                $(this).text((prefixed ? '+ ' : '') + entry.formattedSales);
            });
        } else {
            // Óptica desktop keeps it on the span that also carries the price attribute.
            $pair.find('[data-blue-filter-price], [data-fotocromatic-price]')
                .text(entry.formattedSales);
        }

        $pair.find('.addon-list-price').text(entry.promotion ? entry.formattedList : '');
    });

    // The data attributes feed the footer maths and live on switches as well as on
    // price spans, so they are updated by name wherever they appear for this SKU.
    var addonAttributes = [
        { price: 'blue-filter-price', list: 'blue-filter-list-price' },
        { price: 'fotocromatic-price', list: 'fotocromatic-list-price' },
        { price: 'adds-price', list: 'adds-list-price' },
        { price: 'adds-extra-curvo-price', list: 'adds-extra-curvo-list-price' }
    ];

    addonAttributes.forEach(function (attr) {
        $('[data-' + attr.price + ']').filter(function () {
            var $node = $(this);
            if ($node.closest('.addon-price-pair[data-addon-sku="' + sku + '"]').length) {
                return true;
            }
            var info = $node.data('adds-extra') || $node.data('info');
            if (info && info.Id === sku) {
                return true;
            }
            return $node.closest('.modal-cristales-switch').data('filter-id') === sku;
        }).each(function () {
            $(this)
                .attr('data-' + attr.price, entry.sales)
                .data(attr.price, entry.sales)
                .attr('data-' + attr.list, entry.list)
                .data(attr.list, entry.list);
        });
    });
}

/**
 * Fetches the checkout-accurate complement prices for this frame and paints them into
 * the modal, then recalculates the footer from the patched DOM.
 *
 * The server renders list prices, because dw.campaign.Promotion.getPromotionalPrice
 * cannot resolve these campaigns. The real numbers come from a basket simulation, which
 * is why this runs on modal open instead of on every PDP render.
 *
 * @returns {void}
 */
function loadLensPrices() {
    var url = $('.pdp__cristales-prices-url').val();
    var pid = $('[data-main-productid]').data('main-productid');

    if (!url || !pid) {
        return;
    }

    // The server renders list prices, so without this the shopper would read a price and
    // watch it drop a second later. Showing "calculating" is better than showing a number
    // that is about to change.
    var $priceAreas = $('.modal__pack-grid, .mobile-cristales-grid, .modal__subtotal');
    $priceAreas.addClass('lens-prices-loading');

    $.ajax({
        url: url,
        method: 'GET',
        data: { pid: pid },
        dataType: 'json'
    }).always(function () {
        $priceAreas.removeClass('lens-prices-loading');
    }).done(function (data) {
        if (!data || !data.prices) {
            return;
        }

        Object.keys(data.prices).forEach(function (sku) {
            applyComplementPrice(sku, data.prices[sku]);
        });

        // The footer sums the DOM, so recalculating rebuilds every summary line and the
        // three totals from the values just painted.
        toggleChangePriceTableModal($('[data-selected-lens]'));
    }).fail(function () {
        // Leaving list prices on screen is the safe degradation: never show less than
        // the checkout will charge.
    });
}

function toggleChangePriceTableModal($this) {
    var lensPrice, lensName, total;

    if(!$this) return;

    var productIds = $("[data-main-productid]").data("main-productid");

    if ($this.length > 1) {
        if (screen.width > 991) {
            $this = $($this[0]);
        } else if (screen.width <= 991) {
            $this = $($this[1]);
        }
    }

    var tipoProducto = $("[data-tipo-producto]").val();

    function checkSwitchesColorActive(total, productIds) {
        var switches = $(".adds-extra-switchs");
        if (switches.is(":checked")) {
            if ($(".adds-extra-switchs:checked")) {
                var addonPrice = $(".adds-extra-switchs:checked").data(
                    "adds-price"
                );
                total = parseInt(total) + parseInt(addonPrice);
                var addonId = $(".adds-extra-switchs:checked").data(
                    "adds-extra"
                ).Id;
                productIds = productIds + "," + addonId;
            }
        } else {
            $("#curvo-si-adds").prop("checked", false);
            $("[data-product-addon-extra]").text("");
        }
        return [total, productIds];
    }

    function checkSwitchesCurvoActive(total, productIds) {
        var switchesCurvo = $("#curvo-si-adds");
        if (switchesCurvo.is(":checked")) {
            var extraCurvoData = switchesCurvo.data("info");
            var extraCurvoId = extraCurvoData.Id;
            var extraCurvoName = extraCurvoData.fullName;
            var extraCurvoPrice = switchesCurvo.data("adds-extra-curvo-price");
            renderSummaryLine($("[data-product-addon-extra]"), extraCurvoName + ":", extraCurvoPrice, switchesCurvo.data("adds-extra-curvo-list-price"));
            total = parseInt(total) + parseInt(extraCurvoPrice);
            productIds = productIds + "," + extraCurvoId;
        }
        return [total, productIds];
    }

    let productPrice = parseInt($("[data-main-product-price]").data("main-product-price"));

    if ($this.is("[data-selected-lens]")) {
        $("[data-product-filter]").text("");
        const packId = $this.data("glass-id");

        // The BLANCO pack drops the frame promotion; every other pack restores it.
        // Both branches must assign: the jQuery data key re-read at the top of this
        // function used to keep the list price forever once BLANCO had been picked.
        // .attr() bypasses the data cache and returns what the template rendered.
        if(packId === whitePackSKU) {
          productPrice = parseInt($("[data-main-product-base-price]").data("main-product-base-price"));
        } else {
          productPrice = parseInt($("[data-main-product-price]").attr("data-main-product-price"));
        }

        $('[data-main-product-price]').text(commonHelpers.formatMoneyToClp(productPrice));
        $("[data-main-product-price]").data("main-product-price", productPrice);

        lensPrice = $this.find("[data-price-glass]").data('price-glass');
        lensName = $this.find("[data-full-name]").data("full-name");
        lensName = capitalizeFirstLetters(lensName);

        var FilterPrice,FilterId, FilterName, addon;

        total = productPrice + parseInt(lensPrice);

        var lensListPrice = $this.find("[data-price-glass]").data('list-price-glass');

        renderSummaryLine($("[data-product-cristal]"), lensName, lensPrice, lensListPrice);

        $("[data-product-cristal]").data('product-cristal-value', lensPrice);
        // SPT insurance tiers are keyed on list prices; keep feeding it the undiscounted
        // value. jQuery's .data(key, undefined) is a no-op, so an undefined here would
        // leave the previous pack's list price in place and pick the wrong tier.
        $("[data-product-cristal]").data('product-cristal-list-value',
            lensListPrice === undefined ? null : lensListPrice);

        productIds = productIds + "," + packId;

        addon = $(".extra-filter-switchs");

        if(addon.is(":checked")){
            var [FilterPrice, FilterId, FilterName, FilterListPrice] = verifyIfAddonIsUnique(addon)
            total = parseInt(total) + parseInt(FilterPrice);
            productIds = productIds + "," + FilterId;
            renderSummaryLine($("[data-product-filter]"), FilterName + ":", FilterPrice, FilterListPrice);
        }

        if (tipoProducto == "sol") {
            [total, productIds] = checkSwitchesColorActive(total, productIds);
            [total, productIds] = checkSwitchesCurvoActive(total, productIds);
        }
    }

    if ($this.is(".adds-extra-switchs")) {
        var productIds = $("[data-main-productid]").data("main-productid") + "," + $("[data-selected-lens]").data("glass-id");

        total = productPrice + parseInt($("[data-selected-lens]").find("[data-price-glass]").data('price-glass'));

        $("[data-product-addon]").text("");

        if ($this.prop("checked")) {
            var infoPack = $this.data("adds-extra");
            var addonPrice = $this.data("adds-price");
            var addonName = infoPack.fullName;
            var addonId = infoPack.Id;

            renderSummaryLine($("[data-product-addon]"), addonName + ":", addonPrice, $this.data("adds-list-price"));

            total = parseInt(total) + parseInt(addonPrice);
            productIds = productIds + "," + addonId;
        } else {
            $("[data-product-addon]").text("");
            total = parseInt(total);
            productIds = productIds;
            $("[data-product-addon-extra]").text("");
            $("#curvo-si-adds").prop("checked", false);
        }

        [total, productIds] = checkSwitchesCurvoActive(total, productIds);
    }

    if ($this.is("#curvo-si-adds")) {
        var productIds = $("[data-main-productid]").data("main-productid") + "," + $("[data-selected-lens]").data("glass-id");
        total = productPrice + parseInt($("[data-selected-lens]").find("[data-price-glass]").data('price-glass'));

        $("[data-product-addon-extra]").text("");

        [total, productIds] = checkSwitchesColorActive(total, productIds);

        if ($this.prop("checked")) {
            var extraCurvoData = $this.data("info");
            var extraCurvoId = extraCurvoData.Id;
            var extraCurvoName = extraCurvoData.fullName;
            var extraCurvoPrice = $this.data("adds-extra-curvo-price");

            renderSummaryLine($("[data-product-addon-extra]"), extraCurvoName + ":", extraCurvoPrice, $this.data("adds-extra-curvo-list-price"));

            total = parseInt(total) + parseInt(extraCurvoPrice);
            productIds = productIds + "," + extraCurvoId;
        }
    }

    if ($this.is(".extra-filter-switchs") || $this.is(".extra-filter-switchs-fotocromatic")) {
        $("[data-product-filter]").text("");
        var productIds = $("[data-main-productid]").data("main-productid") + "," + $('[data-selected-lens]').data("glass-id");
        var total = productPrice + parseInt($('[data-selected-lens]').find("[data-price-glass]").data('price-glass'));

        if($this.is(":checked")) {
            var [FilterPrice, FilterId, FilterName, FilterListPrice] = verifyIfAddonIsUnique($this)
            if(FilterPrice != 'null' && FilterId != undefined) {
                total = parseInt(total) + parseInt(FilterPrice);
                productIds = productIds + "," + FilterId;
                renderSummaryLine($("[data-product-filter]"), FilterName + ":", FilterPrice, FilterListPrice);
            }
            cleanSwitchesFotocromatic($this);
        }
        fotocromaticFeature();
        enableDisableBtn($this);
        selectJustOneFilter($this);
    }

    $("[data-subtotal]").text(commonHelpers.formatMoneyToClp(total));
    $("[data-subtotal]").attr('data-total-value', total);
    renderTotalsBlock(total);
    $(".product-detail").attr("data-pid", productIds);
    $('body').trigger('pdp:afterUpdateModalGLasessPrices', $this);
}

function verifyIfCristalesOpticos() {
    if ($(".pdp__seleccionar-cristales").length > 0) {
        var selectedColumn = $(".pack-column[data-selected-lens]");
        toggleChangePriceTableModal(selectedColumn);
    }
}

$("[data-pdpcuotas]").empty().text(commonHelpers.formatMoneyToClp(pdpCoutas));

function bttnSelectecGlass(){
  $(".btnGlassSelect").on('click', function (e) {
    var $this = $(this).offsetParent();
    let blueLigthSwitch = $('#filtro-azul-option-cristalesMobile');
    let $fotocromaticSwitch = $('#fotocromatico-option-cristales-mobile')
    let $extraFilterSwitchesFotocromatic = $('.extra-filter-switchs-fotocromatic')
    $(".pack-column.info").removeClass("selected mobile-selected");
    $(".pack-column.info").removeAttr("data-selected-lens");

    if ($(this).offsetParent().hasClass("card")) {
        $(this).closest('.card.pack-column').addClass("mobile-selected");
    } else {
        $(this).offsetParent().addClass("selected");
    }

    $(this).offsetParent().attr("data-selected-lens", "");

    if (isMobile) { // Valida if screen is mobile or desk
      //uncheck each switch when user switch pack column
      if (blueLigthSwitch.is(':checked')) {
        blueLigthSwitch.trigger('click');
      }

      if ($extraFilterSwitchesFotocromatic && $extraFilterSwitchesFotocromatic instanceof jQuery && $extraFilterSwitchesFotocromatic.length > 0) {
        $extraFilterSwitchesFotocromatic.each(function() {
          if($(this).is(':checked')) {
            $(this).trigger('click');
          }
        });
      }

      if ($fotocromaticSwitch && $fotocromaticSwitch instanceof jQuery && $fotocromaticSwitch.is(':checked')) {
        $fotocromaticSwitch.trigger('click');
      }
    } else {
        if ($this.find("[data-pack-name]").length > 0) {
          var pack = $this.find("[data-pack-name]").data("pack-name");
          if (!pack || (pack != "plata" && pack != "oro")) {
              $(".filtro-luz-azul-wrapper").hide(250);
              $("#filtro-azul-option-cristales").prop("checked", false);
              $("#fotocromatico-option-cristales, #fotocromatico-option-cristales-mobile").prop("checked", false);
          } else {
              $(".filtro-luz-azul-wrapper").show(250);
          }
        }
    }

    // Store selected package for treatment filtering
    var selectedPackageId = $this.data('glass-id');
    if (selectedPackageId) {
        $('body').attr('data-selected-package', selectedPackageId);
        // Update treatments based on selected package
        updateTreatmentsForPackage(selectedPackageId);
    }

    toggleChangePriceTableModal($(this).offsetParent());

    if($this.data('glass-id') === whitePackSKU && !$('#whitepack-advertising-modal').is(':visible')) {
        $('#whitepack-advertising-modal').modal('show');
    }
  });
}

/**
 * @description - blueLigthExtras function that valid the packs availables to blueLigth pack
 * @param {string} pack - pack selected by user
 */
function blueLigthExtras(pack, isGoldOrSilver, isMobile) {
    const blueLightsExtra = $('.blue-Lights-extra').data('packs-apply-for-blue-light');
    const containerFotocromatic = $('.modal__fotocromatico');
    const separatorFotocromatic = $('.separator-fotocromatic-rombo-figure');
    const blueLightsDescription = $('.luz-azul-description');

    if (!blueLightsExtra) {
        return;
    }

    if (isMobile){
        if (blueLightsExtra.includes(pack)) {
            containerFotocromatic.addClass('d-none');
            blueLightsDescription.addClass('not-border');
        } else {
            containerFotocromatic.removeClass('d-none');
            blueLightsDescription.removeClass('not-border');
        }
        return;
    }

    if (blueLightsExtra.includes(pack) || isGoldOrSilver) {
        $(".filtro-luz-azul-wrapper").show();
        containerFotocromatic.addClass('d-none');
        separatorFotocromatic.removeClass('d-md-flex');
        separatorFotocromatic.addClass('d-none');
    } else {
        $(".filtro-luz-azul-wrapper").hide();
        containerFotocromatic.removeClass('d-none');
        separatorFotocromatic.addClass('d-md-flex');
        separatorFotocromatic.removeClass('d-none');
    }

    if (isGoldOrSilver) {
        containerFotocromatic.removeClass('d-none');
        separatorFotocromatic.addClass('d-md-flex');
        separatorFotocromatic.removeClass('d-none');
    }
}

$("#pdp__cristales-modal").on('click', '.pack-column-desktop', function (e) {
    var $this = $(this);
    $(".pack-column.info").removeClass("selected mobile-selected");
    $(".pack-column.info").removeAttr("data-selected-lens");
    if ($(this).hasClass("card")) {
        $(this).addClass("mobile-selected");
    } else {
        $(this).addClass("selected");
    }
    $(this).attr("data-selected-lens", "");
    if ($this.find("[data-pack-name]").length > 0) {
        var pack = $this.find("[data-pack-name]").data("pack-name");
        if (!pack || (pack != "plata" && pack != "oro")) {
            $(".filtro-luz-azul-wrapper").hide();
            $("#filtro-azul-option-cristales").prop("checked", false);
            $("#fotocromatico-option-cristales, #fotocromatico-option-cristales-mobile").prop("checked", false);
            blueLigthExtras(pack, false);
        } else {
            $(".filtro-luz-azul-wrapper").show();
            blueLigthExtras(pack, true);
        }
    }
    
    // Store selected package for treatment filtering
    var selectedPackageId = $this.data('glass-id');
    if (selectedPackageId) {
        $('body').attr('data-selected-package', selectedPackageId);
        // Update treatments based on selected package
        updateTreatmentsForPackage(selectedPackageId);
    }
    
    toggleChangePriceTableModal($this);
});

$("#pdp__cristales-modal").on('click', '.modal-cristales-switch', function () {
    var selectedColumn = $(".pack-column[data-selected-lens]");
    toggleChangePriceTableModal(selectedColumn);
});

$(".quant-input").change(function () {
    if ($(".same-formula").prop("checked")) {
        $(".receta-quant-right-eye").val($(".receta-quant-left-eye").val());
    }
    var quantity =
        parseInt($(".receta-quant-left-eye").val()) +
        parseInt($(".receta-quant-right-eye").val());

    if (quantity > 0) {
        $(".contacto-subtotal").removeClass("d-none");
    } else {
        $(".contacto-subtotal").addClass("d-none");
    }

    var unitValue = $("[data-base-product-price]").text();
    var total = quantity * parseInt(unitValue);
    $("[data-main-product-price]").text(commonHelpers.formatMoneyToClp(unitValue));
    $("[data-subtotal]").text(commonHelpers.formatMoneyToClp(total));
});

$('#pdp__cristales-modal').on('change', '.pack-column', function (e) {
    var $this = $(this);
    toggleChangePriceTableModal($this);
});

$("#pdp__cristales-modal").on('click', '.pack.continuar', function (e) {
    $('.receta.regresar span').html(btnGoBackModalHTMLContent);
    const selectedPack = $('.pack-column.selected,.pack-column.mobile-selected').first();
    const selectedPackName = selectedPack.data('pack-name')
    const selectedPackId = selectedPack.data('glass-id')
    const addonSelected = $('.adds-extra-switchs:checked');
    if ($(this).hasClass('disabled-custom-fotocromatic')) {
      showOrHideErrorFotocromatic(true);
      return;
    } else {
      showOrHideErrorFotocromatic(false);
    }

    if(selectedPackName !== 'Bronce') {
        $('.adicionales .Espejado').addClass('d-none');
        $('.adicionales .Espejado .adds-extra-switchs').prop('checked') ? $('.adicionales .Espejado .adds-extra-switchs').trigger('click') : null;
        $('.adicionales .Espejado .adds-extra-switchs').prop('disabled', true);
    }else {
        $('.adicionales .Espejado').removeClass('d-none');
        $('.adicionales .Espejado .adds-extra-switchs').prop('disabled', false);
    }

    $(".pack-step-block").fadeToggle(400); //toggle pack glasses
    $(".pack-buttons").addClass("d-none");
    addonSelected && addonSelected.trigger('click');
    $(".adds-extra-options-colors .option-wrapper").remove();


    if ($(this).hasClass("sol")) {
        $(".adds-extra-step-block").fadeToggle(400);
        $(".tratamientos-buttons").removeClass("d-none");
        $('.tratamientos.continuar').prop('disabled', true);
        $('.cristales__back-button').removeAttr("disabled");
        $('.cristales__back-button').removeClass('receta regresar');
        $('.cristales__back-button').addClass('tratamientos regresar');
        if (isMobile) {
          toggleVisibility($('#sol-cristales-steps2-mobile'), true);
          toggleVisibility($('#sol-cristales-steps1-mobile'), false);
          $('.stepTwoMiddle').removeClass('d-none');
          $('.stepTwo').addClass('d-none');
          $('.status-cristal .status-cristal-line[data-step="3"]').css('border-bottom-color', '#1058c3');
          updateTreatmentsForPackage(selectedPackId)
          handleStepChangeBtn(2)
          $('.main-title.adicionales-sol-tratamientos').removeClass('d-none');
        }
    } else {
        if (isMobile) {
          let packName = selectedPack.find('[data-pack-name]').data('pack-name');
          let isBlueFilterPage = $('#btnContinuarMobile').attr('bluestep');
          let isGoldOrSilver = (packName.indexOf('plata') != -1 || packName.indexOf('oro') != -1);
          let blueLightsExtra = $('.blue-Lights-extra') ? $('.blue-Lights-extra').data('packs-apply-for-blue-light') : [];
            isBlueFilterActive = $('.step-filtro-luz-azul-wrapper').css('display') === 'block' ? true:false;
            const $sptInsuranceContainer = $('#spt-insurance-full-container');
            const hasSPT = $sptInsuranceContainer.length > 0;
            if (packName=='plata' || packName=='oro' || blueLightsExtra.includes(packName) || hasSPT) {
              $(".stepTwo").removeClass("d-none");
              $(".stepThree").addClass("d-none");
              if (isBlueFilterActive && (isBlueFilterPage === 'true' || isBlueFilterPage === true)) {
                $(".stepTwo").addClass("d-none"); 
                $(".stepThree").removeClass("d-none");
                $(".pack-step-block").hide(); //toggle pack glasses
                showRecetaStep();
                $('#btnContinuarMobile').attr('bluestep', false);
              }
              showBlueStep(false);
              blueLigthExtras(packName, isGoldOrSilver, isMobile);

              if(packName!=='plata' && packName!=='oro' && !blueLightsExtra.includes(packName) && hasSPT) {
                $('.step-filtro-luz-azul-wrapper').addClass('d-none');

                if(isBlueFilterPage && isBlueFilterPage === 'true') {
                  $('.step-filtro-luz-azul-wrapper').removeClass('d-none');
                  $(".pack-step-block").hide(); //toggle pack glasses

                  if($(".stepTwo").is(':visible')) {
                    $(".stepTwo").addClass("d-none"); 
                    $(".stepThree").removeClass("d-none");
                    $('.step-filtro-luz-azul-wrapper').addClass('d-none');
                    showRecetaStep();
                    $('#btnContinuarMobile').attr('bluestep', false);
                  }
                }
              }
            } else {
              showRecetaStep();
              $(".stepTwo").addClass("d-none");
              $(".stepThree").removeClass("d-none");
            }
        } else {
          // desk
          $(".step-filtro-luz-azul-wrapper").addClass("d-none");
          $(".receta-step-block").fadeToggle(400);
          $(".receta-buttons").removeClass("d-none");
          $('.cristales__back-button').prop('disabled', false);
        }
    }

    handleStepChange('next');

    recetaHelpers.canBeAddedToCart();

    $('body').trigger('pdp:packNextStep', {target: $(this)});
});

function changeShippingDate (isSolarOptic) {
  const shippingDateSecondary = $('.shipping-dates-secondary');
  const shippingDatePrimary = $('.promise_ship').not($('.shipping-dates-secondary .promise_ship'));

  if (isSolarOptic && shippingDateSecondary && shippingDateSecondary.length > 0) {
    shippingDateSecondary.show(150);
    shippingDatePrimary.hide(150);
  } else {
    shippingDateSecondary.hide(150);
    shippingDatePrimary.show(150);
  }
}

function showBlueStep(val) {
  $(".step-filtro-luz-azul-wrapper").fadeToggle(400);
  $(".filtro-luz-azul-wrapper").show()
  $(".step-filtro-luz-azul-wrapper").removeClass("d-none");
  // Disable btn continuar on blue filter section
  $('#btnContinuarMobile').prop('disabled', val);
  $('#btnContinuarMobile').attr('bluestep', true);
  $(".pack-buttons").removeClass("d-none");
  $(".tratamientos-buttons").removeClass("d-none");
  $('.tratamientos.continuar').prop('disabled', true);
  $('.cristales__back-button').prop('disabled', false);
}

function showRecetaStep() {
  $(".receta-step-block").fadeToggle(400);
  $(".pack-buttons").removeClass("d-none");
  $('.footer-buttons__continuar').addClass('d-none');
  $('.footer-buttons__continuar.addToCart').removeClass('d-none');
  $('.cristales__back-button ').prop('disabled', false);
  $(".receta-buttons").removeClass("d-none");
}

function toggleContinuarBtn(val) {
  // Next two lines, manage if: add to car and continuar btn are visibles
  $('.footer-buttons__continuar').removeClass('d-none');
  $('.footer-buttons__continuar.addToCart').addClass('d-none');
  $('.cristales__back-button').prop('disabled', false);
  $('#btnContinuarMobile').prop('disabled', val);
}

$(document).on('click', '.modal__pack-grid .pack-column[data-glass-id="' + whitePackSKU + '"]', function (e) {
  $('.pdp-mensaje-pack-blanco-desktop').removeClass('d-none');
});

$(document).on('click', '.modal__pack-grid .pack-column[data-glass-id!="' + whitePackSKU +'"]', function (e) {
  $('.pdp-mensaje-pack-blanco-desktop').addClass('d-none');
});

$('#pdp__cristales-modal').on('click', '.tratamientos.regresar', function () {
    const isSolModal = $("#pdp__cristales-modal .pack.continuar").hasClass("sol");
    const currentPackName = $("#pdp__cristales-modal .pack-column-desktop.selected");
    const currentPackNameMobile = $("#pdp__cristales-modal .mobile-selected");
    let isBtnRegresarActive = $('.cristales__back-button').hasClass('regresar tratamientos');
    let addonExtra = $(".adds-extra-options-wrapper");
    let addonExtraExtra = $(".adds-extra-options-colors");

    const currentStep = getCurrentStep()

    if (isSolModal && isMobile && currentStep === 2) { 
      if (addonExtraExtra.hasClass('d-none')) {
        const selectedPackId = currentPackNameMobile.data('glass-id')
        
        updateTreatmentsForPackage(selectedPackId)

        addonExtra.addClass('d-none');
        handleStepChangeBtn(-1);
        $('.tratamientos.continuar').prop('disabled', false);
        return;
      } else {
        addonExtra.removeClass('d-none');
        addonExtraExtra.addClass('d-none');
        handleStepChangeBtn(-1);
        $('.tratamientos.continuar').prop('disabled', false);
        return;
      }
    }
    
    if (isSolModal && isMobile && isBtnRegresarActive){
      changeClassSolModalMobil();
      $(".receta.regresar.sol").trigger('click');
      return;
    } else {
      changeClassSolModalMobil('sol');
      $('.cristales__back-button').attr('disabled', 'disabled');
      disabledBtnRegresarModal();
    }
    
    if ($(this).data('flow-product-optic-sol') === 'sol' && isMobile) {
        $('.stepTwoMiddle').addClass('d-none');
        $('.stepTwo').removeClass('d-none');
        $('.status-cristal .status-cristal-line[data-step="3"]').css('border-bottom-color', '#bababa');
        toggleVisibility($('#sol-cristales-steps1-mobile'), true);
        toggleVisibility($('#sol-cristales-steps2-mobile'), false);
    }
    $(".pack-step-block").fadeToggle(400);
    $(".adds-extra-step-block").fadeToggle(400);

    $(".pack-buttons").removeClass("d-none");
    $(".tratamientos-buttons").addClass("d-none");

    handleStepChange('prev');
    $(".adds-extra-switchs:checked").trigger('click');
    if (isMobile) {
      toggleChangePriceTableModal(currentPackNameMobile);
    } else {
      toggleChangePriceTableModal(currentPackName); 
    }

    $('body').trigger('pdp:onBackTratamientosStep');
});

$('#pdp__cristales-modal').on('click', '.tratamientos.continuar', function () {
  let $elemento = $('.tratamientos.continuar').attr('sol-step');
  let solStep = parseInt($elemento);
  let isSolMobile = $('.sol-mobile').is(':visible');
  let $selected = $(".mobile-cristales-grid .sol-optic-last-item.mobile-selected");
  let packageName = $selected.length ? $selected.data('pack-name').toLowerCase() : null;
  const tratamientoSelected = $(".adds-extra-switchs:checked").data("addsExtra");
  const tratamientoName = tratamientoSelected ? tratamientoSelected.name : null;

    if ($('.cristales__back-button').hasClass('tratamientos regresar')){
        if ((solStep <= 2 && isSolMobile) && (packageName === 'bronce') && (tratamientoName && tratamientoName === 'Teñido')) {
          $(`input[data-step="${solStep}"]:checked`).trigger('change');
          return;
        }
       changeClassSolModalMobil('sol');
        $(".stepTwo").addClass("d-none");
        $(".stepTwoMiddle").addClass("d-none");
        $(".stepThree").removeClass("d-none");
        $('.status-cristal .status-cristal-line[data-step="4"]').css('border-bottom-color', '#1058c3');
     }
    $(".receta-step-block").fadeToggle(400);
    $(".adds-extra-step-block").fadeToggle(400);
    $(".receta-buttons").removeClass("d-none");
    $(".tratamientos-buttons").addClass("d-none");

    handleStepChange('next');

    $('body').trigger('pdp:packNextStep');
});

$('.btn-close-alert').on('click', function () {
  $(this).offsetParent().removeClass('show');
});

$('#pdp__cristales-modal').on('click', '.receta.regresar', function () {
    const placeHolderDistanciaPupilar = $('.carga-distancia-pupilar').attr('placeholder');
    const selectedPack = $('.pack-column.selected,.pack-column.mobile-selected');
    const packName = selectedPack.find('[data-pack-name]').data('pack-name');
    let home = $('.pack-step-block').css('display') == 'block' ? true:false;
    let blueLightsExtra = $('.blue-Lights-extra') ? $('.blue-Lights-extra').data('packs-apply-for-blue-light') : [];

    changePlaceHolder(placeHolderDistanciaPupilar);

    $(".receta-step-block").fadeToggle(400);
    $(".receta-buttons").addClass("d-none");

    if ($(this).hasClass("sol")) {
      $('.cristales__back-button').removeClass('receta regresar sol');
      $('.cristales__back-button').addClass('tratamientos regresar');
      $(".adds-extra-step-block").fadeToggle(400);
      $(".tratamientos-buttons").removeClass("d-none");
    } else {
        if (isMobile) {
          const $sptInsuranceContainer = $('#spt-insurance-full-container');
          const hasSPT = $sptInsuranceContainer.length > 0;
          if (packName==='plata' || packName==='oro' || blueLightsExtra.includes(packName) || hasSPT) {
              isBlueFilterActive = $('.step-filtro-luz-azul-wrapper').css('display') == 'block' ? true:false;

              if (isBlueFilterActive) {
                $(".step-filtro-luz-azul-wrapper").fadeToggle(400);
                $(".pack-step-block").fadeToggle(400);
              } else {
                showBlueStep(true);
                toggleContinuarBtn(false);

                if(!blueLightsExtra.includes(packName) && hasSPT) {
                  $('.step-filtro-luz-azul-wrapper').addClass('d-none');
                  $(".pack-step-block").fadeToggle(400);
                  $('#btnContinuarMobile').attr('bluestep', false);
                }
              }
          } else{
                $(".pack-step-block").fadeToggle(400);
                $(".pack-buttons").removeClass("d-none");

                // Next two lines, manage if: add to car and continuar btn are visibles
                toggleContinuarBtn(true);
            }
        } else {
          // desk
          $(".pack-step-block").fadeToggle(400);
          $(".pack-buttons").removeClass("d-none");
          $(".step-filtro-luz-azul-wrapper").removeClass("d-none");

          // Next two lines, manage if: add to car and continuar btn are visibles
          $('.footer-buttons__continuar').removeClass('d-none');
          $('.footer-buttons__continuar.addToCart').addClass('d-none');
          $('.cristales__back-button').prop('disabled', true);
        }
    }

    $('#btnContinuarMobile').prop('disabled', false);

    /* Mobile */
    if ($(this).data('flow-product-optic-sol') === 'sol' && isMobile) {
        $('.stepTwoMiddle').removeClass("d-none");
        $('.stepTwo').addClass('d-none');
        $('.stepThree').addClass('d-none');
        $('.status-cristal .status-cristal-line[data-step="4"]').css('border-bottom-color', '#bababa');

    } else {
        $('.stepTwo').removeClass("d-none");
        $('.stepThree').addClass('d-none'); 
    }

    handleStepChange('prev');

    home = $('.pack-step-block').css('display') == 'block' ? true:false;

    if (home) {
      $('.cristales__back-button').prop('disabled', true);
      
      if(isMobile) {
        $('#btnContinuarMobile').attr('bluestep', false);
        $(".receta-step-block").hide();
      }        

       disabledBtnRegresarModal();
    }

    $('body').trigger('pdp:onBackRecetaStep');
});

$('.receta-step-block, .receta-accordion-form-container').on('show.bs.collapse','.collapse', function() {
    $('.receta-step-block, .receta-accordion-form-container').find('.collapse.show').siblings('.card-header').children(".fa").toggleClass("rotate-icon-down");
    $('.receta-step-block, .receta-accordion-form-container').find('.collapse.show').collapse('hide');
});

$(".card-header").click(function () {
    $(this).children(".fa").toggleClass("rotate-icon-down");

    if ($('.receta-accordion-form.ajaxCargaReceta').length > 0 && !$('.receta-accordion-form.ajaxCargaReceta').is(":visible")) {
        $('.receta-accordion-form.ajaxCargaReceta').show();
    }
});

$("[data-customCarouselPDP]").on('afterChange', function(event, slick, currentSlide) {
    var $navigator = $("[data-customPDPNavigator]");

    if ($navigator.hasClass('slick-initialized') && $navigator.slick('slickCurrentSlide') !== currentSlide) {
        $navigator.slick('slickGoTo', currentSlide, true);
    }
});

$("[data-customPDPNavigator]").on('afterChange', function(slick, currentSlide) {
  const $rykCarouselBullets = $(".ryk-carousel-bullets")
  $rykCarouselBullets.removeClass("ryk-carousel-selected-border");

  const $nextArrow = currentSlide.$nextArrow;
  const $slides = currentSlide.$slides

  const $activeSlide = $slides.filter('.slick-current.slick-active')
  const $activeSlideBullet = $activeSlide.find('img')

  $activeSlideBullet.addClass("ryk-carousel-selected-border");

  const $lastSlide = $($slides[$slides.length - 1])

  //Make sure last element being disabled due carousel has infinite off
  if(!$lastSlide.hasClass('slick-current') && $nextArrow && $nextArrow.hasClass('slick-disabled')){
    $nextArrow.removeClass('slick-disabled')
    $nextArrow.attr('aria-disabled', false)
  }
})

$("[data-customPDPNavigator]").on('breakpoint', function(event, slick, breakpoint){
    if (breakpoint === 769) {
        slick.slickGoTo(0, true);
    }
});

$('#switch-to-cristales').on('change', function() {
  $('body').trigger('pdp:changeSwitchToCristales');

  if ($("#switch-to-cristales").prop("checked")) {
    $(".addToCart-sol").hide(150);
    $(".pdp__cristales-sol-button").show(150);
    $(".link-isapre").addClass('d-block');
    $("._rm").addClass('d-none');
    $(".update_recipe").show(150);
    $(".spt-insurance-info").removeClass('d-none')
    var selectedColumn = $(".pack-column[data-selected-lens]");
    toggleChangePriceTableModal(selectedColumn);
  } else {
    $(".pdp__cristales-sol-button").hide(150);
    $(".update_recipe").hide(150);
    $(".spt-insurance-info").addClass('d-none')
    $(".addToCart-sol").show(150);
    $(".link-isapre").removeClass('d-block');
    $("._rm").removeClass('d-none');
    var productIds = $("[data-main-productid]").data("main-productid");
    $(".product-detail").attr("data-pid", productIds);
  }

  recetaHelpers.canBeAddedToCart();
  changeShippingDate($("#switch-to-cristales").prop("checked"));
});

function generateSelector(list) {
  let result = [];

  for(ele of list){
    if (ele !== '') {
      result.push('.'+ele);
    }
  }
  return result.join(',');
}

/**
 * Update treatments based on selected package
 */
function updateTreatmentsForPackage(packageId) {
    console.log('=== updateTreatmentsForPackage START ===');
    console.log('Package ID:', packageId);
    
    // Only update for solar products
    var tipoProducto = $('[data-tipo-producto]').val();
    console.log('Tipo producto:', tipoProducto);
    
    if (tipoProducto === 'sol') {
        // Get package configuration from data attributes
        var packagesConfig = $('[data-solar-packages]').data('solar-packages');
        var colorsConfig = $('[data-solar-colors]').data('solar-colors');
        
        console.log('Packages config:', packagesConfig);
        console.log('Colors config:', colorsConfig);
        
        if (!packagesConfig || !colorsConfig) {
            console.log('Missing configs, returning');
            return;
        }
        
        // Find package by ID
        var selectedPackage = null;
        for (var packageKey in packagesConfig) {
            if (packagesConfig[packageKey].id === packageId) {
                selectedPackage = packagesConfig[packageKey];
                break;
            }
        }
        
        console.log('Selected package:', selectedPackage);
        
        if (!selectedPackage) {
            console.log('No package found, returning');
            return;
        }
        
        const $treatments = $('.adicionales-sol-tratamientos')
        // Hide all treatments first
        $treatments.addClass('d-none');
        
        // Show treatments based on package configuration
        var treatments = selectedPackage.treatments;
        console.log('Package treatments:', treatments);
        
        for (var treatmentKey in treatments) {
            var treatment = treatments[treatmentKey];
            console.log('Processing treatment:', treatment);
            
            // Buscar elementos que contengan el ID del tratamiento
            $treatments.each(function() {
                var $element = $(this);
                var addOnData = $element.find('input[data-adds-extra]').data('adds-extra');
                
                if (addOnData && addOnData.Id === treatment.id) {
                    console.log('Found matching treatment element, showing:', treatment.id);
                    $element.removeClass('d-none');
                }
            });
        }
        
        //Hide last separator
        const $treatmentsVisibles = $('.adicionales-sol-tratamientos:not(.d-none)');
        if($treatmentsVisibles.length > 1) {
          const [$mobileTreatment, $desktopTreatment] = [
            $($treatmentsVisibles[$treatmentsVisibles.length - 1]), 
            $($treatmentsVisibles[$treatmentsVisibles.length - 2])
          ]
          
          //Exist separated markup for mobile and desktop so always we should evaluate both cases
          $mobileTreatment.find('.rhombus-separator-adds').addClass('d-none');
          $desktopTreatment.find('.rhombus-separator-adds').addClass('d-none');
        }
        
        // Update treatment data for dynamic content
        updateTreatmentData(selectedPackage, colorsConfig);
    }
    console.log('=== updateTreatmentsForPackage END ===');
}

/**
 * Update treatment data for dynamic content generation
 */
function updateTreatmentData(packageConfig, colorsConfig) {
    // Store package configuration for later use
    $('body').data('selected-package-config', packageConfig);
    $('body').data('colors-config', colorsConfig);
    
    // Update treatment elements with correct data attributes
    var treatments = packageConfig.treatments;
    for (var treatmentKey in treatments) {
        var treatment = treatments[treatmentKey];
        
        $('.adicionales-sol-tratamientos').each(function() {
            var $element = $(this);
            var addOnData = $element.find('input[data-adds-extra]').data('adds-extra');
            
            if (addOnData && addOnData.Id === treatment.id) {
                // Update data attributes for dynamic color loading
                $element.find('input[data-adds-extra]').attr('data-treatment-config', JSON.stringify(treatment));
                $element.find('input[data-adds-extra]').attr('data-package-id', packageConfig.id);
                
                // Handle different flows based on package
                var packageName = packageConfig.name.toLowerCase();
                
                if (packageName === 'plata' || packageName === 'platino') {
                    // Plata and Platino: Show colors directly without toggles
                    if (treatment.types) {
                        // Use solido colors directly
                        var solidoColors = treatment.types.solido ? treatment.types.solido.colors : [];
                        treatment.colors = solidoColors;
                        delete treatment.types; // Remove types to show colors directly
                    }
                } else if (packageName === 'oro') {
                    // Oro: Show only Polarizado treatment
                    if (treatmentKey === 'polarizado') {
                        // Keep only the colors, remove any type structure
                        if (treatment.types) {
                            // Flatten all colors from all types
                            var allColors = [];
                            for (var typeKey in treatment.types) {
                                if (treatment.types[typeKey].colors) {
                                    allColors = allColors.concat(treatment.types[typeKey].colors);
                                }
                            }
                            treatment.colors = allColors;
                            delete treatment.types;
                        }
                    }
                }
                // Bronce keeps the original structure with types
            }
        });
    }
}

/**
 * Get description for type toggle
 */
function getTypeDescription(typeKey) {
    var descriptions = {
        'solido': 'Lentes tintados a elección de manera uniforme para mejor experiencia.',
        'degrade': 'Los cristales son tintados en degradé, de manera que el color del lente se va atenuando.'
    };
    
    return descriptions[typeKey] || 'Tipo de tratamiento especializado.';
}

/**
 * Fill activity attributes for color options
 */
function fillAttributesInColor(container, attributes) {
    var attributesList = $('[data-adicionales]').data('color-attributes');
    var templateColorAttributes = document.querySelector("template#adds_attributes");
    
    console.log('fillAttributesInColor called with attributes:', attributes);
    console.log('attributesList from body data:', attributesList);
    console.log('templateColorAttributes:', templateColorAttributes);
    
    // DEBUG: Verificar el elemento data-adicionales
    var adicionalesElement = $('[data-adicionales]')[0];
    console.log('DEBUG: adicionalesElement found:', !!adicionalesElement);
    if (adicionalesElement) {
        console.log('DEBUG: data-color-attributes attribute:', adicionalesElement.getAttribute('data-color-attributes'));
        console.log('DEBUG: data-color-attributes dataset:', adicionalesElement.dataset.colorAttributes);
    }
    
    // Try alternative selectors if the first one fails
    if (!templateColorAttributes) {
        templateColorAttributes = document.querySelector('template#adds_attributes');
        console.log('Trying alternative selector, found:', templateColorAttributes);
    }
    
    if (!templateColorAttributes) {
        templateColorAttributes = $('template#adds_attributes')[0];
        console.log('Trying jQuery selector, found:', templateColorAttributes);
    }
    
    // FALLBACK: Si attributesList está vacío, usar datos hardcodeados
    if (!attributesList || (typeof attributesList === 'object' && Object.keys(attributesList).length === 0)) {
        console.log('DEBUG: attributesList is empty, using hardcoded fallback');
        attributesList = [
            {"id":"pesca","name":"Pesca","icon":"pescar.png"},
            {"id":"manejar","name":"Manejar","icon":"manejar.png"},
            {"id":"golf","name":"Golf","icon":"golf.png"},
            {"id":"aireLibre","name":"Actividades al aire Libre","icon":"airelibre.png"},
            {"id":"bicicleta","name":"Bicicleta","icon":"bici.png"},
            {"id":"leer","name":"Leer","icon":"leer.png"},
            {"id":"tenis","name":"Tenis","icon":"tenis.png"},
            {"id":"acuaSports","name":"Deportes acuaticos","icon":"deporteacuatico.png"},
            {"id":"ski","name":"Ski","icon":"ski.png"}
        ];
        console.log('DEBUG: Using hardcoded attributesList:', attributesList);
    }
    
    if (!templateColorAttributes) {
        console.log('Missing template');
        console.log('Template found:', !!templateColorAttributes);
        return;
    }
    
    // Convert array to object if needed
    var attributesMap = {};
    
    console.log('Raw attributesList type:', typeof attributesList);
    console.log('Raw attributesList isArray:', Array.isArray(attributesList));
    console.log('Raw attributesList length:', attributesList ? attributesList.length : 'undefined');
    
    // First, try to parse if it's a string
    if (typeof attributesList === 'string') {
        console.log('Parsing string attributesList');
        try {
            attributesList = JSON.parse(attributesList);
            //parse again in case of double stringified JSON
            if(typeof attributesList === 'string'){
              attributesList = JSON.parse(attributesList);
            }
            console.log('Parsed successfully, new type:', typeof attributesList);
            console.log('Parsed successfully, isArray:', Array.isArray(attributesList));
        } catch (e) {
            console.log('Failed to parse JSON:', e);
            return;
        }
    }
    
    if (Array.isArray(attributesList)) {
        console.log('Converting array to object, length:', attributesList.length);
        for (var j = 0; j < attributesList.length; j++) {
            var attr = attributesList[j];
            console.log('Array item at', j, ':', attr);
            if (attr && typeof attr === 'object' && attr.id) {
                attributesMap[attr.id] = attr;
                console.log('Added to map:', attr.id, '->', attr);
            } else {
                console.log('Skipping invalid attr at index', j, ':', attr);
            }
        }
    } else if (attributesList && typeof attributesList === 'object') {
        // If it's already an object but has numeric keys, convert it
        var keys = Object.keys(attributesList);
        var firstKey = keys[0];
        console.log('Object keys:', keys);
        console.log('First key:', firstKey);
        
        if (firstKey === '0' || firstKey === '1' || /^\d+$/.test(firstKey)) {
            console.log('Converting object with numeric keys to proper map');
            for (var key in attributesList) {
                var item = attributesList[key];
                console.log('Object item at key', key, ':', item);
                if (item && typeof item === 'object' && item.id) {
                    attributesMap[item.id] = item;
                    console.log('Added object item to map:', item.id, '->', item);
                } else {
                    console.log('Skipping invalid object item at key', key, ':', item);
                }
            }
        } else {
            console.log('Using object as-is');
            attributesMap = attributesList;
        }
    } else {
        console.log('attributesList is not array or object after parsing:', attributesList);
    }

    console.log('Final attributesMap keys:', Object.keys(attributesMap));
    console.log('Final attributesMap sample:', attributesMap[Object.keys(attributesMap)[0]]);
    
    for (var i = 0; i < attributes.length; i++) {
        var attributeId = attributes[i];
        var attributeConfig = attributesMap[attributeId];

        console.log('Processing attribute:', attributeId, 'config:', attributeConfig);

        if (attributeConfig && attributeConfig.icon) {
            console.log('Found icon for attribute:', attributeId, 'icon:', attributeConfig.icon);

            var contentColorAttributes = templateColorAttributes.content.cloneNode(true);
            var separatorSvg = contentColorAttributes.querySelector(".separator-svg");

            if (separatorSvg) {
                var src = separatorSvg.src;
                src = src + attributeConfig.icon;
                separatorSvg.setAttribute("src", src);
                separatorSvg.setAttribute("alt", attributeConfig.name || '');
                console.log('Set icon src to:', src);
            }

            var extraSubtext = contentColorAttributes.querySelector(".extra-subtext");
            if (extraSubtext) {
                extraSubtext.textContent = attributeConfig.name || '';
                console.log('Set icon text to:', attributeConfig.name);
            }

            container.append(contentColorAttributes);
            console.log('Added icon template for attribute:', attributeId);
        } else {
            console.log('No icon found for attribute:', attributeId, 'Available attributes:', Object.keys(attributesMap));
        }
    }
}

/**
 * Fill solar optic colors based on new configuration
 */
function fillSolarOpticColors(optionsContainer, $this) {
    var data = $this.data("adds-extra");
    var treatmentId = data.Id;
    var treatmentName = data.name;
    
    // Get package and treatment configuration
    var packagesConfig = $('body').data('selected-package-config');
    var colorsConfig = $('body').data('colors-config');
    
    if (!packagesConfig || !colorsConfig) {
        console.log('Missing package or colors config');
        return;
    }
    
    // Find the treatment configuration
    var treatmentConfig = null;
    for (var packageKey in packagesConfig.treatments) {
        if (packagesConfig.treatments[packageKey].id === treatmentId) {
            treatmentConfig = packagesConfig.treatments[packageKey];
            break;
        }
    }
    
    if (!treatmentConfig) {
        console.log('Treatment config not found for:', treatmentId);
        return;
    }
    
    console.log('Treatment config found:', treatmentConfig);
    
    // Clear existing options
    optionsContainer.empty();
    
    if (treatmentConfig.types) {
        // Handle treatments with types (like Teñido with Sólido/Degradé)
        console.log('Treatment has types:', treatmentConfig.types);
        
        // Create section for type toggles only
        var typeSection = $('<div class="type-toggles-section"></div>');
        
        for (var typeKey in treatmentConfig.types) {
            var type = treatmentConfig.types[typeKey];
            console.log('Processing type:', typeKey, type);
            
            // Create type toggle using existing template
            var typeTemplate = $('#adds-extra-bronce-template').clone().html();
            var $typeTemplate = $(typeTemplate);
            
            $typeTemplate.find('.title').text(type.name);
            $typeTemplate.find('.description').text(getTypeDescription(typeKey));
            $typeTemplate.find('.checkbox').attr('id', 'type_' + typeKey);
            $typeTemplate.find('.checkbox').attr('data-type-id', typeKey);
            $typeTemplate.find('.checkbox').attr('data-displayname', type.name);
            $typeTemplate.find('.checkbox').addClass('type-switch-options');
            $typeTemplate.find('.checkbox').addClass('color-type-toggle');
            
            // Hide price for type toggles
            $typeTemplate.find('.price').hide();

            //include only the current type tooltip
            const excludedTooltipPopUps = $typeTemplate.find(`.tooltip-pop-up:not(.${typeKey})`);
            excludedTooltipPopUps.remove();

            typeSection.append($typeTemplate);
        }
        
        optionsContainer.append(typeSection);
        
        // Create separate section for colors (initially hidden)
        var colorSection = $('<div class="color-section js-color-section" style="display: none;"></div>');
        optionsContainer.append(colorSection);
        
        // Store treatment config for later use
        $this.data('treatment-config', treatmentConfig);
    } else if (treatmentConfig.colors) {
        // Handle treatments with direct colors (like Espejado, Polarizado)
        console.log('Treatment has direct colors:', treatmentConfig.colors);
        
        for (var i = 0; i < treatmentConfig.colors.length; i++) {
            var colorId = treatmentConfig.colors[i];
            var colorConfig = colorsConfig.find(color => color.id === colorId);
            
            if (colorConfig) {
                var template = $('#adds-extra-bronce-template').html();
                var $template = $(template);

                const labName = colorConfig.labName[treatmentName.toLowerCase()];
                
                $template.find('.title').text(colorConfig.name);
                $template.find('.modal__tooltip').remove();
                $template.find('.description').text(colorConfig.description);
                $template.find('.checkbox').attr('id', colorId);
                $template.find('.checkbox').attr('data-labname', labName);
                $template.find('.checkbox').attr('data-color-id', colorId);
                $template.find('.checkbox').attr('data-displayname', colorConfig.name);
                $template.find('.checkbox').attr('data-sku', $this.data("adds-extra").Id);
                $template.find('.checkbox').addClass('color-switch-options');
                
                // Add activity attributes if available
                if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                    fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
                }

                if(colorConfig.attributes && !Array.isArray(colorConfig.attributes) && typeof colorConfig.attributes === 'object') {
                    fillAttributesInColor($template.find('.adds-extra-icons'), Object.keys(colorConfig.attributes).filter(key => colorConfig.attributes[key]));
                }
                
                optionsContainer.append($template);
            }
        }
    }
}

/**
 * Fill treatment sub-colors based on configuration
 */
function fillTreatmentSubColors(container, treatmentConfig, $element) {
    console.log('fillTreatmentSubColors called with:', container, treatmentConfig, $element);
    
    var colorsConfig = $('body').data('colors-config');
    var types = treatmentConfig.types;
    var selectedType = $element.data('displayname');
    
    console.log('Colors config:', colorsConfig);
    console.log('Types:', types);
    console.log('Selected type:', selectedType);
    
    // Find the selected type - map display names to config keys
    var typeKey = selectedType.toLowerCase();
    if (selectedType === 'Degradé') typeKey = 'degrade';
    if (selectedType === 'Sólido') typeKey = 'solido';
    
    var selectedTypeConfig = types[typeKey];
    if (!selectedTypeConfig) {
        console.log('Selected type not found:', selectedType, 'mapped to:', typeKey, 'Available types:', Object.keys(types));
        return;
    }
    
    var colors = selectedTypeConfig.colors;
    console.log('Colors for selected type:', colors);
    
    // Clear ALL existing colors in the color section (both solido and degrade)
    var colorSection = container.find('.color-section.js-color-section');
    if (colorSection.length === 0) {
        colorSection = $('<div class="color-section js-color-section"></div>');
        container.append(colorSection);
    }
    colorSection.empty();
    
    // Add blue header for color section with same structure as other sections
    // Get the correct URL by finding an existing pink-frame image and copying its src
    var existingPinkFrame = $('.pink-frame').first();
    var frameSrc = existingPinkFrame.length ? existingPinkFrame.attr('src') : '/on/demandware.static/-/Library-Sites-RyKSharedLibrary/default/v1758023311995/images/modalCristales/carga-receta-frame.svg';
    
    var colorHeader = $('<div class="upload-your-recipe-title d-flex col-md-12 mt-1" data-not-apply-border-radius="true" data-not-apply-backround-image="true">' +
        '<span class="main-title">3.2 Elige el color de teñido ' + selectedType +'</span>' +
        '<div class="upload-your-recipe-frame hidden-sm-down">' +
            '<img class="pink-frame" src="' + frameSrc + '" alt="filtro-azul-pc">' +
        '</div>' +
        '</div>');
    colorSection.append(colorHeader);
    
    // Add colors ONLY for the selected type
    for (var i = 0; i < colors.length; i++) {
        var colorId = colors[i];
        var colorConfig = colorsConfig.find(color => color.id === colorId);
        
        console.log('Processing color:', colorId, colorConfig);
        
        if (colorConfig) {
            // Create a separate section for each color
            var colorItemSection = $('<div class="color-item-section"></div>');
            
            var template = $('#adds-extra-bronce-template').html();
            var $template = $(template);

            const labName = colorConfig.labName[treatmentConfig.name.toLowerCase()];
            
            $template.find('.title').text(colorConfig.name);
            $template.find('.description').text(colorConfig.description);
            $template.find('.checkbox').attr('id', colorId + '_' + selectedType);
            $template.find('.checkbox').attr('data-labname', labName);
            $template.find('.checkbox').attr('data-color-id', colorId);
            $template.find('.checkbox').attr('data-type-id', selectedType);
            $template.find('.checkbox').attr('data-displayname', colorConfig.name);
            $template.find('.checkbox').addClass('color-switch-options');
            $template.find('.modal__tooltip').remove();
            
            // Add activity attributes if available
            if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
            }

            if(colorConfig.attributes && !Array.isArray(colorConfig.attributes) && typeof colorConfig.attributes === 'object') {
                fillAttributesInColor($template.find('.adds-extra-icons'), Object.keys(colorConfig.attributes).filter(key => colorConfig.attributes[key]));
            }
            
            colorItemSection.append($template);
            colorSection.append(colorItemSection);
            console.log('Added color template to separate section');
        }
    }

    const hasColorItemSection = colorSection.find('.color-item-section').length > 0

    if(hasColorItemSection) {
      $('.tratamientos.continuar').prop('disabled', true);
    }
    
    // Show the color section
    colorSection.show();
    console.log('Color section shown, total elements:', colorSection.find('.option-wrapper').length);
}

$(document).on('mouseenter', '.modal__tooltip', function() {
  $('.tooltip-pop-up').css('visibility', 'hidden');

  setTimeout(() => {
    $(this).siblings('.tooltip-pop-up').css('visibility', 'visible');
  }, 10);

  const customCarouselModalCristales = $('[data-customCarouselModalCristales]')
  customCarouselModalCristales.each(function(){
    if(!$(this).hasClass('slick-initialized')) {
      $(this).slick({
          slidesToShow: 1,
          dots: true,
          infinite: true,
          arrows: false
      })
    }
  })

  customCarouselModalCristales.slick('slickUnfilter');

  //Generate tooltip slides based of which dialogs you want to show, ex1: solido polarizado, ex2: degrade
  let tooltipsInfo = $(this).data('tooltips');
  if(tooltipsInfo !== undefined) {
    let list = tooltipsInfo.trim().split(' ');
    let cssSelector;
    if (list.length > 0) {
      cssSelector = generateSelector(list);
    }
    $('[data-customCarouselModalCristales]').slick('slickFilter', cssSelector);
  }
  
  $('[data-customCarouselModalCristales]').slick('refresh');
  $('[data-customCarouselModalCristales]').resize();
});

$(".graduacion.receta").click(function () {
    $(".graduacion.caja").removeClass("active-button");
    $(".graduacion.receta").addClass("active-button");
    $(".img-container.caja").addClass("d-none");
    $(".img-container.receta").removeClass("d-none");
});

$(".graduacion.caja").click(function () {
    $(".graduacion.receta").removeClass("active-button");
    $(".graduacion.caja").addClass("active-button");
    $(".img-container.receta").addClass("d-none");
    $(".img-container.caja").removeClass("d-none");
});

$(".attribute-tabs__tab").click(function () {
    $(".attribute-tabs__tab").removeClass("attribute-tab-selected-border");
    $(this).addClass("attribute-tab-selected-border");
    $(".tab-block").addClass("d-none");
    if ($(this).hasClass("first")) $(".tab-block.first").removeClass("d-none");
    if ($(this).hasClass("sec")) $(".tab-block.sec").removeClass("d-none");
    if ($(this).hasClass("third")) $(".tab-block.third").removeClass("d-none");
});

$(".tooltip-pop-up").hover(
    function () {
      mouseIsInside = true;
    },
    function () {
      mouseIsInside = false;
    }
);

$("body").mouseup(function () {
    if (!mouseIsInside) $(".tooltip-pop-up").css("visibility", "hidden");
});

function addsExtraSwitchsChange(){
  $(".adds-extra-switchs, .adds-extra-switchs-mobile").change(function () {
    let titleDyedType = $(this).data('title-dyed-type');
    let titleColor = $(this).data('title-color');
    let titleColorEspejado = $(this).data('title-color-espejado');
    const tratamientoSelected = $(this).data("treatment-config");
    const $selectedPack = $('.pack-column.selected,.pack-column.mobile-selected').first();
    const packName = $selectedPack.data('pack-name').toLowerCase();
    const $extraOptionsWrapperTitle = $('.adds-extra-options-wrapper .main-title');

    if(tratamientoSelected && tratamientoSelected.types && tratamientoSelected.name === 'Teñido' && packName === 'bronce') {
      $extraOptionsWrapperTitle.text(titleDyedType);
    }else if(tratamientoSelected && tratamientoSelected.name === 'Espejado' && $(this).hasClass('mobile')) {
      $extraOptionsWrapperTitle.text(titleColorEspejado)
    }else if(tratamientoSelected && tratamientoSelected.name === 'Teñido' && packName !== 'bronce' && $(this).hasClass('mobile')){
      $extraOptionsWrapperTitle.text('3.1 Elige el color de teñido sólido')
    }else {
      $extraOptionsWrapperTitle.text(titleColor);
    }

    let isSolMobile = $('.sol-mobile').is(':visible');
    $(".adds-color-options").empty();
    $(".adds-extra-options-wrapper").slideUp(400);
    $(".elige-extra-curvo").slideUp(400);
    $(".adds-extra-options-colors").slideUp(400);
    var id = $(this).attr("id");
    var $this = $(this);
    let addonExtra = $(".adds-extra-options-wrapper");
    let addon = $('.adicionales-sol-tratamientos');
    let element = '.adds-extra-switchs';
    if ($this.prop("checked")) {
        handleStepChangeBtn(1);
        if (isSolMobile) {
          element = '.adds-extra-switchs.mobile';
        } 
        recetaHelpers.checkIfUnique(element, id);
        var optionsContainer = $(".adds-color-options");
        
        // Use new solar optic color logic
        fillSolarOpticColors(optionsContainer, $this);
        
        $(".adds-extra-options-wrapper").slideDown(400);
        $(".elige-extra-curvo").slideDown(400);
    } else {
      if (!addon.hasClass('d-none')) {
        $('[data-product-addon]').text('');
        $('[data-product-addon-color]').text('');
        $('.tratamientos.continuar').prop('disabled', true);
        return;
      }
    }
    $("[data-product-addon-color]").text("");
    toggleChangePriceTableModal($this);
    $('.tratamientos.continuar').prop('disabled', true);
    // $(".adds-sub-color-options").addClass('d-none');

    if (isSolMobile) {
      $('.adicionales-sol-tratamientos').addClass('d-none');
      addonExtra.hasClass('d-none') && addonExtra.removeClass('d-none');
    }
  });
}

$(".link-astigmatismo").click(function () {
    var filterData = $("[data-filter]").data("filter");
    localStorage.setItem("filter", filterData);
    localStorage.setItem("refinement", $("[data-filter]").data("refinement"));
});
function validateidsTypes(idsTypes,id,colorName,colorAnterior) {
  const selectedTypes = $('.type-toggles-section input[type="checkbox"]:checked').map(function () {
    return $(this).data('displayname');
}).get();
  let stringColorName = "";
    let fillType; 
    if (idsTypes.includes(id)) {
        $("[data-product-addon-color]").text("");
        if (!fillType) {
            fillType = colorName;
        }
    } else {
      $("[data-product-addon-color]").text("");
      stringColorName = selectedTypes[0] ? selectedTypes[0] + " - " + colorName : colorName;
      fillType = stringColorName;
    }

    return fillType;
}

function capitalizeFirstLetters(str) {
  return str
    .split(' ') // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words back together
}

$(document).on("change", ".adds-sub-colors", function () {
  let id = $(this).attr("id");
  let currentColorSelected = $(this).data('displayname');
  let parentColor = $(this).data('parent-name');
  let colorText = isMobile ? $('.tratamientos-buttons [data-product-addon-color]') : $('#product-addon-color');
  if ($(this).is(":checked")) {
    colorText.text(`Color: ${parentColor} - ${currentColorSelected}`);
    $('.tratamientos.continuar').prop('disabled', false);
  } else {
    colorText.text(`Color: ${parentColor}`);
    $('.tratamientos.continuar').prop('disabled', true);
}
  colorText.text(capitalizeFirstLetters(colorText.text()));
  recetaHelpers.checkIfUnique(".adds-sub-colors", id);
});

$(document).on("change", ".color-switch-options", function () {
    var id = $(this).attr("id");
    const colorAnterior = $("[data-product-addon-color]").last().text().trim();
    const idsTypes = $('.type-toggles-section input[type="checkbox"]').map(function () {
    return this.id;
    }).get();

    $('.tratamientos.continuar').prop('disabled', true);
    let optionsContainer = $(".adds-extra-options-colors");
    optionsContainer.find(".option-wrapper").remove();

    if ($(this).is(":checked")) {
        var colorName = $(this).data("displayname");
        colorName = validateidsTypes(idsTypes,id,colorName,colorAnterior);
        $("[data-product-addon-color]").text(capitalizeFirstLetters("Color: " + colorName));
        let isSolMobile = $('.sol-mobile').is(':visible');
        $('.tratamientos.continuar').prop('disabled', false);
        
        // Use new solar optic logic for type toggles
        if (colorName === 'solido' || colorName === 'degrade') {
            // Find the color section in the current treatment container
            var treatmentContainer = $(this).closest('.adds-color-options');
            var colorSection = treatmentContainer.find('.color-section.js-color-section');
            
            if (colorSection.length === 0) {
                colorSection = $('<div class="color-section js-color-section"></div>');
                treatmentContainer.append(colorSection);
            }
            
            // Get treatment config from the selected treatment
            var selectedTreatment = $('.adds-extra-switchs:checked');
            var treatmentConfig = selectedTreatment.data('treatment-config');
            
            console.log('Treatment config for colors:', treatmentConfig);
            console.log('Selected type:', colorName);
            
            if (treatmentConfig && treatmentConfig.types) {
                fillTreatmentSubColors(treatmentContainer, treatmentConfig, $(this));
            }
            
            if (isSolMobile) {
                $('.adds-extra-options-wrapper').addClass('d-none');
                handleStepChangeBtn(1);
            }
            $('.tratamientos.continuar').prop('disabled', true);
        }
    } else {
        optionsContainer.addClass('d-none');
    }

    // Only check uniqueness for color options, not type toggles
    if (!$(this).hasClass('color-type-toggle')) {
        recetaHelpers.checkIfUnique(".color-switch-options:not(.color-type-toggle)", id);
    }
});

$(document).on("change", "#curvo-si-adds", function () {
    toggleChangePriceTableModal($(this));
});

var dPupModal = document.querySelector("#infoDistanciaModal");
var dPupModalOpenButton = document.querySelector(".d-pup-info-trigger");
var dPupModalCloseButton = document.querySelector(".d-pup-info-close");

if (dPupModal) {
  dPupModalOpenButton.addEventListener('click', function() {
    dPupModal.show();
  });

  dPupModalCloseButton.addEventListener('click', function() {
    dPupModal.close();
  });
}

var mobileTooltipDialog = document.querySelector('#mobileTooltipsTrigger');
var mobileTooltipDialogAddOns = document.querySelector('#mobileTooltipsInfoAddOns');

var mobileTooltipDialogOpenButton = document.querySelector('#mobileTooltipsTrigger');
var mobileTooltipDialogOpenButtonAddOns = document.querySelector('#mobileTooltipsTrigger-addOns');

var mobileTooltipDialogCloseButton = document.querySelector('.mob-tooltip-info-close');
var mobileTooltipDialogCloseButtonAddOns = document.querySelector('.mob-tooltip-info-close-addOns');
const tooltipCloseButtonMobile = $('.tooltip-close-mobile');
const tooltipCloseButton = $('.tooltip-close');

if (mobileTooltipDialog) {
  if (mobileTooltipDialogOpenButton) {
    mobileTooltipDialogOpenButton.addEventListener('click', function() {
      mobileTooltipDialog.show();
    });
  }
  mobileTooltipDialogCloseButton.addEventListener('click', function() {
    mobileTooltipDialog.close();
  });

  mobileTooltipDialogOpenButtonAddOns.addEventListener('click', function() {
    mobileTooltipDialogAddOns.show();
  });
  mobileTooltipDialogCloseButtonAddOns.addEventListener('click', function() {
    mobileTooltipDialogAddOns.close();
  });
}

if (tooltipCloseButton) {
  tooltipCloseButton.click(function() {
    $(this).parent().css('visibility', 'hidden');
  });
};

if (tooltipCloseButtonMobile) {
  tooltipCloseButtonMobile.click(function() {
    $(this).parent().css('visibility', 'hidden');
  });
};

$('#pdp__cristales-modal').on('change', '[data-pupillar-distance]', function() {
    recetaHelpers.canBeAddedToCart();
});

$("#pdp__cristales-modal").on('change', '.extra-filter-switchs', function () {
    var $this = $(this);
    var id = $this.attr('id');
    recetaHelpers.checkIfUnique(".extra-filter-switchs", id);
    toggleChangePriceTableModal($this);

});

$("#pdp__cristales-modal").on('change', '.extra-filter-switchs-fotocromatic', function () {
  toggleChangePriceTableModal($(this));
  verifyIfCristalesOpticos();
});

$('#pdp__cristales-modal').on('hidden.bs.modal', function (event) {
    verifyIfCristalesOpticos();
});

$('#pdp__cristales-modal').on('shown.bs.modal', function () {
    // The Auglio widget bubble is injected with z-index 9999999 and sits above every
    // modal on the site. Inside this one it covers a price, so it steps aside while the
    // shopper is choosing lenses. Scoped to this modal on purpose: the widget's
    // behaviour everywhere else is not ours to change.
    $('body').addClass('cristales-modal-open');
    loadLensPrices();
});

$('#pdp__cristales-modal').on('hidden.bs.modal', function () {
    $('body').removeClass('cristales-modal-open');
});

$('body').on('product:afterAddToCart', function (ev, data) {
  if (!data.error && isMobile) {
    if($('.carga-distancia-pupilar').val() && $('.carga-distancia-pupilar').val().length > 0) {
      const subscriptionRecipeUrlSelector = $('.tab-subscription-pdp.active').length > 0 ? '#subscriptionRecipeUrl' : '#recipeUrl';
      const placeHolder = $('#carga-receta').attr("placeholder");

      $('#receta-file-name span').html(placeHolder);
      $('#receta-file-name').removeClass('load');
      $('.carga-distancia-pupilar').removeClass('load');
      $('.carga-distancia-pupilar').val('');
      $('[data-target="#modalCristalesAccordion1"]').trigger('click');

      $(subscriptionRecipeUrlSelector).val('');
    }

    // Limpia ultima rut seccion
    if($('#recetaRut') && $('#recetaRut').val() && $('#recetaRut').val().length > 0) {
      $('#recetaRut').val('');
      $('.buscar-receta-button').trigger('click');
      // $('#recetaRut').removeAttr("style");
      $('[data-target="#modalCristalesAccordion2"]').trigger('click');

      setTimeout(function() {
        $('.invalid-feedback').hide();
        $('#recetaRut').removeAttr("style");
      }, 2000);
    }
  }
});

function clearModalMobil() {
  $('button.add-to-cart, button.add-to-cart-global').click(function () {
    if (isMobile) {
      const selectedPack = $('.pack-column.selected,.pack-column.mobile-selected');
      const packName = selectedPack.find('[data-pack-name]').data('pack-name');
      if (packName==='plata' || packName==='oro') {
        isBlueFilterActive = $('.step-filtro-luz-azul-wrapper').css('display') == 'block' ? true:false;
        if (isBlueFilterActive) {
          $(".step-filtro-luz-azul-wrapper").fadeToggle(400);
          $(".receta-step-block").fadeToggle(400);
          $(".pack-step-block").fadeToggle(400);
        }
      } else {
            $(".receta-step-block").fadeToggle(400);
            $(".pack-step-block").fadeToggle(400);
      }

      $('.receta.regresar').trigger('click');
    }
  });
}

// Functions
function changeClassSolModalMobil(sol){
  $('.cristales__back-button').removeClass('tratamientos regresar');
  $('.cristales__back-button').addClass('receta regresar');
  sol !== undefined ? $('.cristales__back-button').addClass('sol') : '';
}

$('.tab-buy-one-pdp').on('click', function (event) {
  $('.repite-receta-button').addClass('d-none');
  $('.repeat-order-button').removeClass('d-none');
  $('.repeat-order-button').trigger('click');
});

$('.tab-subscription-pdp').on('click', function (event) {
  $('.repeat-order-button').addClass('d-none');
  $('.repite-receta-button').removeClass('d-none');
  $('.subscription-pdp-content #repite-receta-accordion2-header').trigger('click');
});

$(document).on('click', '[data-open-setting-contact-lens="true"]', function(){
    const posicion = $("#start-date-subscription-container").offset().top;
    $("html, body").animate({
        scrollTop: posicion
    }, 2000);
    setTimeout(function () {
        $('div.subscription-pdp #repite-receta-accordion2-header').click();
    },2000);
});

$('.subscription-pdp .recipe-section').on('shown.bs.collapse', function(event) {
  recetaHelpers.canBeAddedToCart();
});

$('.tabs-suscripcion [data-toggle="tab"]').on('shown.bs.tab', function (ev) {
  recetaHelpers.canBeAddedToCart();
});

$('.specify-diopter-section, .lens-recipe-content').on('show.bs.collapse', function (ev) {
  if($('.contacto-add-to-cart').hasClass('d-none')) {
      $('.contacto-add-to-cart').removeClass('d-none');
      $('.repeat-order-result').empty();
  }
});

repeatOrder.methods.enableOptionDefaultFormRecipeFlowStore();
recetaHelpers.canBeAddedToCart();
verifyIfCristalesOpticos();

/**
 * Update color section title based on selected package
 */
function updateColorSectionTitle() {
    var selectedPack = $('.pack-column.selected, .pack-column.mobile-selected');
    var packName = selectedPack.data('pack-name');
    var colorTitleElement = $('#color-section-title');
    var specificColorTitleElement = $('#specific-color-title');
    
    if (colorTitleElement.length > 0) {
        if (packName && packName.toLowerCase() === 'bronce') {
            // For Bronce: show "3.2 Elige el color con el que quieres teñir tus cristales"
            colorTitleElement.text('3.2 Elige el color con el que quieres teñir tus cristales');
        } else {
            // For other packs: show "3.1 Elige el color con el que quieres teñir tus cristales"
            colorTitleElement.text('3.1 Elige el color con el que quieres teñir tus cristales');
        }
    }
    
    if (specificColorTitleElement.length > 0) {
        if (packName && packName.toLowerCase() === 'bronce') {
            // For Bronce: show "3.2 Elige el color con el que quieres teñir tus cristales"
            specificColorTitleElement.text('3.2 Elige el color con el que quieres teñir tus cristales');
        } else {
            // For other packs: show "3.1 Elige el color con el que quieres teñir tus cristales"
            specificColorTitleElement.text('3.1 Elige el color con el que quieres teñir tus cristales');
        }
    }
}

// Call updateColorSectionTitle when pack selection changes
$(document).on('click', '.pack-column-desktop, .btnGlassSelect', function() {
    setTimeout(updateColorSectionTitle, 100);
});

// Fix for bronce treatments appearing on first load
function fixBronceTreatmentsOnLoad() {
    // Check if there's a pre-selected pack
    var selectedPack = $('.pack-column[data-selected-lens]');
    if (selectedPack.length > 0) {
        var packageId = selectedPack.data('glass-id');
        var packName = selectedPack.data('pack-name');
        
        // Execute updateTreatmentsForPackage for the pre-selected pack
        if (packageId) {
            console.log('Running updateTreatmentsForPackage for pre-selected pack:', packageId, packName);
            updateTreatmentsForPackage(packageId);
        }
        // Also update color section title
        updateColorSectionTitle();
    }
}

// Also run fix when page loads
$(document).ready(function() {
    setTimeout(fixBronceTreatmentsOnLoad, 500);
});

// Additional call when window loads completely
$(window).on('load', function() {
    setTimeout(fixBronceTreatmentsOnLoad, 1000);
});

module.exports = {
  init: init,
  clearModalMobil: clearModalMobil,
  addsExtraSwitchsChange: addsExtraSwitchsChange,
  bttnSelectecGlass: bttnSelectecGlass,
  toggleChangePriceTableModal: toggleChangePriceTableModal,
  fixBronceTreatmentsOnLoad: fixBronceTreatmentsOnLoad
}